import Stack from '@mui/material/Stack';
import * as React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { blue } from '@material-ui/core/colors/';
import DangerousOutlinedIcon from '@mui/icons-material/DangerousOutlined';
import products from '../../data/computer';

import { useHistory } from "react-router-dom";


const ColorButton = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: blue[700],
    '&:hover': {
        backgroundColor: blue[900],
    },
}));
var dateNow = new Date().getTime()
let arrayTrue = []


let dataValidation = products.map((row) => (
    //Se data de vencimento do produto é menor ou igual a 30 dias contando com o dia de hoje 
    new Date(Date.parse(row.expirate)).getTime()) < dateNow ?
    row.licenca :
    null
)
dataValidation.map((a, i) => (
    a != null ?
        arrayTrue[i] = a :
        ''
))
const result = arrayTrue.filter(e => e);


export default function CustomizedButtonsExpirado() {

  const history = useHistory();

  const routeChange = () =>{ 
    let path = '/expired-license' 
    history.push(path);
  }
    return (
        <Stack spacing={2} direction="row">
            <ColorButton
                style={{ minWidth: '100%', minHeight: '3.5rem' }}
                startIcon={<DangerousOutlinedIcon></DangerousOutlinedIcon>}
                onClick={routeChange}
                size="larger" variant="contained">Licenças expiradas:{result.length} 
            </ColorButton>
        </Stack>
    );
}